// extracted by mini-css-extract-plugin
module.exports = {"Tab":"Tab_Tab__32VyQ","TabSelected":"Tab_TabSelected__WoWHJ","TabList":"Tab_TabList__3Y_Z5","TabPanel":"Tab_TabPanel__2gl67"};